export const siteInfo = {
  name: '黑料吃瓜',
  tagline: '最新爆料 · 每日更新',
  description: '📰 黑料吃瓜网是行业领先的娱乐资讯聚合平台，每日汇集全网最新爆料、明星八卦、网红热点与社会话题。我们以"快、准、全"为运营理念，7×24小时不间断更新，确保用户第一时间获取最热门的吃瓜内容。无论你是资深吃瓜群众还是偶尔围观的路人，黑料吃瓜都是你不可错过的资讯入口。',
  heroStats: [
    { label: '每日更新', value: '全天候' },
    { label: '内容覆盖', value: '全网热点' },
    { label: '访问保障', value: '多线路切换' },
  ],
};

export const faqItems = [
  {
    q: '黑料吃瓜网是什么类型的网站？',
    a: '黑料吃瓜网是一个专业的娱乐资讯聚合平台，每日整理和推送全网最新爆料内容，涵盖明星八卦、网红热点、综艺话题等多个领域，是吃瓜群众获取第一手热门资讯的首选入口。',
  },
  {
    q: '黑料吃瓜网的网址入口在哪？',
    a: '您可以通过黑料吃瓜官网入口直接访问本站，我们提供多条备用线路（线路一二三），确保在访问高峰期也能流畅浏览。建议收藏本站首页或关注我们的导航页面获取最新地址。',
  },
  {
    q: '黑料吃瓜网的内容更新频率如何？',
    a: '我们保持7×24小时全天候更新机制，编辑团队实时监控各大社交平台与资讯源，确保热点内容第一时间上线。每日爆料内容涵盖图文、快讯、专题等多种形式，让您不错过任何精彩内容。',
  },
  {
    q: '如何确保访问黑料吃瓜网的稳定性？',
    a: '黑料吃瓜网提供多线路备份方案（线路一二三），当主线路访问出现波动时，系统会自动切换至备用线路。同时建议用户关注我们的最新网址公告，获取有效的黑料吃瓜链接和导航信息。',
  },
];

export const topicItems = [
  { name: '明星恋情', heat: '9.8w', hot: true },
  { name: '综艺翻车', heat: '8.6w', hot: true },
  { name: '网红塌房', heat: '7.9w', hot: true },
  { name: '影视剧透', heat: '7.2w', hot: false },
  { name: '直播事故', heat: '6.5w', hot: false },
  { name: '品牌翻车', heat: '5.8w', hot: false },
  { name: '选秀内幕', heat: '5.3w', hot: false },
  { name: '婚变传闻', heat: '4.9w', hot: false },
  { name: '私生饭事件', heat: '4.4w', hot: false },
  { name: '音乐节瓜', heat: '4.1w', hot: false },
];

export const updateItems = [
  { time: '10分钟前', title: '某顶流男星被拍到深夜密会神秘女子，工作室暂未回应', tag: '最新' },
  { time: '28分钟前', title: '热门综艺录制现场突发意外，导演组紧急叫停拍摄', tag: '快讯' },
  { time: '1小时前', title: '知名品牌代言人陷争议风波，品牌方连夜发布声明', tag: '热点' },
  { time: '2小时前', title: '某女团成员直播中意外曝光组合内部矛盾，粉丝炸锅', tag: '爆料' },
  { time: '3小时前', title: '热门网剧剧组被曝拖欠群演工资，制片人发声回应', tag: '追踪' },
  { time: '4小时前', title: '知名歌手演唱会假唱证据流出，网友逐帧分析实锤', tag: '热议' },
  { time: '5小时前', title: '某综艺选手被扒黑历史，节目组连夜剪辑删除相关镜头', tag: '深扒' },
  { time: '6小时前', title: '网红带货翻车现场实录，产品质量遭消费者集体投诉', tag: '曝光' },
  { time: '8小时前', title: '某演员被拍到深夜出入高档会所，经纪人称是朋友聚会', tag: '吃瓜' },
];

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24小时全天候实时推送，热点事件从发生到上线平均不超过15分钟，确保您永远比朋友圈先知道。',
  },
  {
    icon: 'ri-global-line',
    title: '全网覆盖',
    desc: '内容覆盖微博、抖音、小红书、豆瓣等主流平台，一站汇集所有热门话题，不必在各个App间来回切换。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多线保障',
    desc: '提供线路一二三等多条备用入口，智能切换确保访问稳定，无论何时何地都能流畅浏览最新内容。',
  },
  {
    icon: 'ri-user-star-line',
    title: '深度整理',
    desc: '编辑团队对每条爆料进行核实与梳理，提供事件前因后果完整脉络，让吃瓜吃得明明白白。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '移动优先',
    desc: '全面适配手机端浏览体验，无论通勤路上还是午休间隙，随时随地打开就能追最新爆料和吃瓜动态。',
  },
];

export const mediaItems = [
  {
    title: '顶流男星恋情大揭秘：深夜密会全记录',
    duration: '05:32',
    views: '128.6w',
    tag: '热度爆表',
    imageSeq: 'media-card-01',
  },
  {
    title: '综艺节目录制现场突发事故完整回放',
    duration: '03:18',
    views: '96.3w',
    tag: '今日必看',
    imageSeq: 'media-card-02',
  },
  {
    title: '网红带货翻车事件：消费者集体维权',
    duration: '08:45',
    views: '87.2w',
    tag: '持续发酵',
    imageSeq: 'media-card-03',
  },
  {
    title: '知名歌手演唱会假唱对比音频实锤',
    duration: '04:56',
    views: '73.8w',
    tag: '实锤曝光',
    imageSeq: 'media-card-04',
  },
  {
    title: '某女团成员直播爆料队内不和内幕',
    duration: '06:21',
    views: '65.4w',
    tag: '独家整理',
    imageSeq: 'media-card-05',
  },
];

export const appInfo = {
  title: '随时随地 畅快吃瓜',
  desc: '黑料吃瓜移动端专属入口，适配所有手机浏览器，无需下载App即可获得流畅浏览体验。收藏本站首页，精彩爆料随身带。',
  features: ['免安装即用', '流量消耗低', '多线路自动切换', '消息实时推送'],
};

export const aboutInfo = {
  title: '关于黑料吃瓜',
  content: '黑料吃瓜网创立以来，始终致力于为广大网友提供最新、最全、最及时的娱乐资讯与爆料内容。我们拥有一支经验丰富的编辑团队，全天候关注各大社交平台与资讯源，以严谨的态度和专业的视角，为用户筛选和整理最有价值的吃瓜内容。黑料吃瓜官网入口始终坚持以用户体验为核心，持续优化访问速度和内容质量，已成为数百万吃瓜群众每日必访的资讯平台。',
  stats: [
    { number: '500w+', label: '月活用户' },
    { number: '2000+', label: '日均更新' },
    { number: '3条', label: '备用线路' },
  ],
};

export const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，知情人士曝两人已交往半年', hot: true },
  { rank: 2, title: '热门综艺翻车现场：导演与选手爆发激烈争吵全程被拍', hot: true },
  { rank: 3, title: '知名网红塌房后续：多个品牌连夜解约，违约金或超千万', hot: true },
  { rank: 4, title: '某一线女星被曝婚变，工作室发声明称「纯属谣言」遭质疑', hot: false },
  { rank: 5, title: '选秀节目内幕大公开：选手曝节目组故意剪辑制造矛盾引流', hot: false },
  { rank: 6, title: '直播带货又翻车！消费者实测产品效果与宣传严重不符', hot: false },
  { rank: 7, title: '音乐节保安与粉丝冲突事件全程录像流出，主办方致歉', hot: false },
];

export const indexItems = [
  { title: '明星恋情专题', desc: '最新明星恋情爆料、约会实拍与恋爱时间线整理', count: '36篇', icon: 'ri-heart-line' },
  { title: '综艺翻车合集', desc: '综艺节目录制事故、选手争议与剪辑内幕大盘点', count: '28篇', icon: 'ri-tv-line' },
  { title: '网红塌房实录', desc: '网红翻车事件全程追踪，从走红到塌房的完整纪录', count: '42篇', icon: 'ri-building-2-line' },
  { title: '直播事故汇编', desc: '带货翻车、口误现场与直播中的各种意外名场面', count: '31篇', icon: 'ri-live-line' },
  { title: '婚变传闻追踪', desc: '明星婚变、分手传闻与感情风波的最全时间线梳理', count: '25篇', icon: 'ri-emotion-sad-line' },
  { title: '品牌翻车记录', desc: '品牌代言人争议、产品翻车与公关处理全流程复盘', count: '19篇', icon: 'ri-store-line' },
  { title: '选秀黑幕揭秘', desc: '选秀节目暗箱操作、内定选手与导师偏袒的内幕挖掘', count: '23篇', icon: 'ri-trophy-line' },
  { title: '私生饭事件簿', desc: '私生饭跟踪、骚扰与越界行为的实录与讨论', count: '17篇', icon: 'ri-eye-off-line' },
  { title: '音乐节名场面', desc: '音乐节舞台事故、歌手失态与观众互动的精彩瞬间', count: '15篇', icon: 'ri-music-line' },
];

export const carouselItems = [
  {
    title: '2024年度吃瓜大事件回顾',
    desc: '从顶流塌房到综艺名场面，这一年我们见证了太多不可思议的瞬间。',
    tag: '年度特辑',
    imageSeq: 'carousel-01',
  },
  {
    title: '娱乐圈"未解之谜"深度解析',
    desc: '那些年我们追过的悬案：真相到底如何？一起来看最全梳理。',
    tag: '深度盘点',
    imageSeq: 'carousel-02',
  },
  {
    title: '吃瓜群众必备：全网爆料源指南',
    desc: '想知道最新的瓜从哪来？这份指南帮你快速找到一手资讯源。',
    tag: '实用攻略',
    imageSeq: 'carousel-03',
  },
  {
    title: '本月最热TOP10：你不能错过的瓜',
    desc: '编辑精选本月热度最高的10条爆料，一条比一条精彩。',
    tag: '月度精选',
    imageSeq: 'carousel-04',
  },
];

export const commentItems = [
  { avatar: 'R', name: '吃瓜一线', time: '2小时前', content: '这个瓜太大了！我已经分享给所有群了，朋友圈也都炸了哈哈', likes: 3286 },
  { avatar: '小', name: '小透明不透明', time: '3小时前', content: '终于等到完整梳理了，之前看的都是碎片信息。黑料吃瓜的整理能力一如既往地强！', likes: 2156 },
  { avatar: '热', name: '热心网友小王', time: '4小时前', content: '每天必刷黑料吃瓜，已经成为我的电子榨菜了。更新速度真的快，感谢编辑！', likes: 1892 },
  { avatar: '深', name: '深度吃瓜户', time: '5小时前', content: '相比其他平台，还是这边的内容更全更及时。建议出一个订阅功能，不错过重要更新。', likes: 1567 },
  { avatar: '默', name: '默默围观的路人', time: '6小时前', content: '之前一直找不到稳定入口，现在收藏了黑料吃瓜导航再也不怕迷路了。线路自动切换太实用了。', likes: 1234 },
];

export const cardItems = [
  {
    title: '某顶流男星恋情大起底：从初识到同居时间线全梳理',
    desc: '继深夜密会照片曝光后，更多知情人士出面爆料两人相识相恋的完整过程……',
    tag: '明星恋情',
    time: '3小时前',
    imageSeq: 'card-01',
  },
  {
    title: '热门综艺导演组内部矛盾曝光，节目质量下滑有原因',
    desc: '多名工作人员匿名透露，导演组与投资方在节目方向上存在严重分歧……',
    tag: '综艺内幕',
    time: '5小时前',
    imageSeq: 'card-02',
  },
  {
    title: '网红大V塌房波及面扩大，合作品牌集体解约维权',
    desc: '随着更多黑料被扒出，该网红的商业版图正在迅速崩塌，违约金数额惊人……',
    tag: '网红塌房',
    time: '6小时前',
    imageSeq: 'card-03',
  },
  {
    title: '知名演员被曝税务问题，工作室紧急发布澄清声明',
    desc: '有媒体爆料称某一线演员涉嫌税务违规，金额或达数千万，引发广泛关注……',
    tag: '明星风波',
    time: '8小时前',
    imageSeq: 'card-04',
  },
  {
    title: '直播带货又现翻车名场面：产品质量遭质检报告打脸',
    desc: '消费者送检结果显示，该产品多项指标不达标，与直播中宣传的效果天差地别……',
    tag: '直播翻车',
    time: '10小时前',
    imageSeq: 'card-05',
  },
  {
    title: '音乐节保安打人事件持续发酵，多位目击者站出来发声',
    desc: '事件视频全网播放量已破千万，主办方的道歉声明被认为缺乏诚意……',
    tag: '社会关注',
    time: '12小时前',
    imageSeq: 'card-06',
  },
];

export const contactInfo = {
  title: '联系与投稿',
  desc: '欢迎爆料投稿与合作咨询，您的每一条线索我们都将认真对待。',
  email: 'tougao@heiliao.com',
  tips: ['爆料内容请提供可靠来源', '投稿将在24小时内审核回复', '合作咨询请注明来意'],
};